<template slot-scope="scope">
      <dialogModel
        title="信用评价信息购买"
        :visible.sync="dialogPurchase"
        @handleClose="handleClosePurchase"
        @handleOk="handlePurchase"
      >
        <div class="main-body"></div>
      </dialogModel>
</template>

<script>
export default {
  props: {
    dialogPurchase: {},
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    // 取消 关闭弹窗
    handleClosePurchase() {
      this.$emit("handleClosePurchase");
    },

    // 确认
    handlePurchase() {
      this.$emit("handlePurchase");
    },
  },
};
</script>

<style scoped lang="less">

.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
